Vue.component 'popup',
    template: """
<section class="dim"
     @click="cancel"
     :class='{shown: value}'>
    <div @click.stop="">
        <span class="cancel"
              @click="cancel"></span>
        <slot></slot>
    </div>
</section>
"""
    props: ['value']

    methods:
        cancel: -> @$emit 'input', false

inputMixin =
    props:
        value: String
        label: String
        error:
            type: String
            default: ''
        title:
            type: String
            default: ''
        note:
            type: String
            default: ''
        compulsory: Boolean

    computed:
        spanClass: ->
            compulsory: @compulsory
            "with-hint": @title

        val:
            get: -> @value
            set: (val)-> @$emit 'input', val

phoneMixin =
    methods:
        checkPhone: (event)->
            k = event.key
            return if not @value and k is '+'
            return if k in ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight']
            if isNaN k
                do event.preventDefault

makeInput = (type = 'text', ph = '', mixins = [], keyDownValidateMethod = '')->
    if keyDownValidateMethod
        keyUp = "@keydown='#{keyDownValidateMethod}'"
    input = "<input type='#{type}' placeholder='#{ph}' v-model='val' #{keyUp} />"
    if type is 'textarea'
        input = "<textarea v-model='val' placeholder='#{ph}'></textarea>"

    Vue.component "#{type}-input",
        mixins: [inputMixin, mixins...]
        template: """
    <label>
        <span :class='spanClass' :title='title'>{{label}}</span>
        #{input}
        <aside v-show='note' v-html='note'></aside>
        <small :class='{shown: error != ""}'>{{error}}</small>
    </label>
"""

makeInput 'tel', "7 digits at least", [phoneMixin], 'checkPhone'
makeInput 'text'
makeInput 'date'
makeInput 'email'
makeInput 'textarea'
makeInput 'password'

Vue.component 'form-option',
    template: """
<span :class='{selected: value == name}'
      class='option'
      @click="$emit('input', name)"><slot></slot></span>
"""
    props: ['name', 'value']

Vue.component 'hotline-job',
    template: """
<div class="vacancy"
    :class='{expanded: expanded}'>
    <h2 @click='expanded = !expanded'>
        {{title}}
        <small>
            Renumeration: <b>{{renumeration}}</b>
        </small>
    </h2>
    <div class='copy'>
        <slot></slot>
    </div>
</div>
"""
    props: ['title', 'renumeration']

    data: ->
        expanded: false

Vue.component 'file-upload',
    name: 'file-upload'
    template: """
<div class='upload'>
    <input type='file'
           @change='handleFileUpload'
           ref='fileInput'>
</div>
"""
    data: -> file: null

    methods:
        handleFileUpload:  -> @file = event.target.files[0]
